import { useDispatch, useSelector } from 'react-redux';
import {
  deletePaymentMethod,
  disableInstallmentsCountry,
  editCoverage,
  enableInstallmentsCountry,
  getAllPaymentMethods,
  getInstallmentsCountryInfos,
  postAddPaymentMethod,
  saveCoverage,
} from './actions';
import { PaymentMethodsSelectors } from './selectors';

export const usePaymentMethods = () => {
  const dispatch = useDispatch();

  return {
    loading: useSelector(PaymentMethodsSelectors.getLoading),
    error: useSelector(PaymentMethodsSelectors.getError),
    errorInfo: useSelector(PaymentMethodsSelectors.getErrorInfo),
    paymentMethodsGrouped: useSelector(PaymentMethodsSelectors.getPaymentMethodsGrouped),
    paymentMethodsSelected: useSelector(PaymentMethodsSelectors.getPaymentMethodsSelected),
    showEditCoverage: useSelector(PaymentMethodsSelectors.getShowEditCoverage),
    allPaymentMethods: useSelector(PaymentMethodsSelectors.getAllPaymentMethods),
    statusAdd: useSelector(PaymentMethodsSelectors.getStatusAdd),
    statusDelete: useSelector(PaymentMethodsSelectors.getStatusDelete),
    getAllPaymentMethods: (coutryFilter: string, page: number) => dispatch(getAllPaymentMethods(coutryFilter, page)),
    postAddPaymentMethod: (paymentMethodIds: number[]) => dispatch(postAddPaymentMethod(paymentMethodIds)),
    deletePaymentMethod: (paymentMethodIds: number[]) => dispatch(deletePaymentMethod(paymentMethodIds)),
    editCoverage: (show: boolean) => dispatch(editCoverage(show)),
    saveCoverage: (currentSelection: string[], newSelection: string[]) =>
      dispatch(saveCoverage(currentSelection, newSelection)),
    fetchInstallmentsCountryInfos: () => dispatch(getInstallmentsCountryInfos()),
    installmentsCountryInfos: useSelector(PaymentMethodsSelectors.getInstallmentsCountryInfos),
    enableInstallmentsCountry: (country: string, payer: string) => dispatch(enableInstallmentsCountry(country, payer)),
    disableInstallmentsCountry: (country: string, payer: string) => dispatch(disableInstallmentsCountry(country, payer)),
  };
};
